<script setup lang="ts">
import { computed } from 'vue'

import AppIcon, { type AppIconName } from '@/components/AppIcon.vue'
import { activeNavigationPath } from '@/components/navigation'

export interface MobileTabItem {
  icon: AppIconName
  label: string
  to: string
}

const props = defineProps<{
  items: MobileTabItem[]
  activePath: string
}>()

const selectedPath = computed(() => activeNavigationPath(props.items, props.activePath))
</script>

<template>
  <nav class="mobile-tab-bar" :aria-label="$t('app.terminal')">
    <RouterLink
      v-for="item in items"
      :key="item.to"
      :aria-current="selectedPath === item.to ? 'page' : undefined"
      :class="{ active: selectedPath === item.to }"
      :to="item.to"
    >
      <AppIcon :name="item.icon" size="23px" />
      <span>{{ item.label }}</span>
    </RouterLink>
  </nav>
</template>

<style scoped>
.mobile-tab-bar {
  position: fixed;
  z-index: 30;
  right: 0;
  bottom: 0;
  left: 0;
  display: grid;
  grid-auto-columns: 1fr;
  grid-auto-flow: column;
  border-top: 1px solid var(--color-neutral-100);
  background: rgb(255 253 252 / 97%);
  padding: 8px 8px calc(7px + env(safe-area-inset-bottom));
  box-shadow: 0 -5px 15px rgb(60 37 30 / 6%);
  backdrop-filter: blur(16px);
}

.mobile-tab-bar a {
  display: grid;
  min-height: 49px;
  place-content: center;
  justify-items: center;
  gap: 3px;
  color: var(--color-text-muted);
  font-size: 11px;
  font-weight: 600;
  text-decoration: none;
}

.mobile-tab-bar a.active {
  color: var(--color-brand-blue-700);
}
</style>
